/**
 * Legacy-Redirect: /user_hotspots → /hotspots
 * Alte Production-URL war in Google indexiert — kein 404 produzieren.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/user_hotspots')({
  beforeLoad: () => {
    throw redirect({ to: '/hotspots', replace: true })
  },
  component: () => null,
})
